/* MLOUYE MagSafe v1 (21.10.2026, Website Design): snippets/mlouye-initial-picker.liquid davranışı.
   - URL'de varyant yokken harf seçilmemiş sayılır: sepet düğmeleri "Select an initial" der; gönderim engellenir,
     ipucu yazılır ve odak harf şeridine gider. Seçim Impact'in kendi <variant-picker>'ı ile yapılır.
   - Harf seçilince: etiket "Initial: B", renk balonu linkleri kardeşin aynı harf varyantına gider (?variant=).
   - Şerit okları (yalnız fare) ve kenar maskesi.
   Temanın dosyalarına dokunmaz; olaylar: variant:change (Impact). */
(() => {
  const pickers = document.querySelectorAll('[data-mi-picker]');
  if (!pickers.length) return;

  pickers.forEach((root) => {
    const formId = root.getAttribute('data-form');
    const idx = parseInt(root.getAttribute('data-option-index') || '0', 10);
    const strip = root.querySelector('[data-mi-strip]');
    const hint = root.querySelector('[data-mi-hint]');
    let strings = { select: 'Select an initial', hint: 'Select an initial to continue.' };
    try { strings = Object.assign(strings, JSON.parse(root.querySelector('[data-mi-strings]').textContent)); } catch (e) { /* varsayılan */ }

    const optionName = 'option' + (idx + 1);
    const isChosen = () => !!strip.querySelector(`input[name="${optionName}"]:checked`);
    let chosen = isChosen();

    const submitButtons = () => Array.from(document.querySelectorAll(
      `button[type="submit"][form="${formId}"], form#${CSS.escape(formId)} button[type="submit"], buy-buttons[form="${formId}"] button[type="submit"]`
    ));
    const textEl = (button) => (button.getAttribute('is') === 'custom-button' && button.firstElementChild) ? button.firstElementChild : button;

    function lockButtons() {
      submitButtons().forEach((button) => {
        const el = textEl(button);
        if (!button.hasAttribute('data-mi-locked')) button.setAttribute('data-mi-original', el.innerHTML);
        button.setAttribute('data-mi-locked', '');
        button.setAttribute('aria-describedby', hint.id);
        el.textContent = strings.select;
      });
    }
    function unlockButtons() {
      submitButtons().forEach((button) => {
        button.removeAttribute('data-mi-locked');
        // Metni Impact'in BuyButtons'ı variant:change'te yeniden yazar; olay gelmediyse eski metin geri konur.
        const el = textEl(button);
        if (el.textContent === strings.select && button.hasAttribute('data-mi-original')) el.innerHTML = button.getAttribute('data-mi-original');
      });
    }

    // Seçim yokken gönderimi durdur (Impact'in ProductForm dinleyicisinden önce, capture aşamasında)
    document.addEventListener('submit', (event) => {
      if (chosen || !event.target || event.target.getAttribute('id') !== formId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      hint.textContent = strings.hint;
      root.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      const first = strip.querySelector('input:not(:disabled)');
      if (first) first.focus({ preventScroll: true });
    }, true);

    function updateSiblings(letter) {
      root.querySelectorAll('[data-mi-sibling]').forEach((a) => {
        const map = Object.fromEntries((a.getAttribute('data-variants') || '').split(',').filter(Boolean).map((pair) => {
          const i = pair.lastIndexOf(':');
          return [pair.slice(0, i), pair.slice(i + 1)];
        }));
        const base = a.getAttribute('data-base');
        a.href = letter && map[letter] ? `${base}?variant=${map[letter]}` : base;
      });
    }

    function setChosenUI(letter) {
      const empty = root.querySelector('[data-mi-label-empty]'), full = root.querySelector('[data-mi-label-full]');
      if (empty) empty.hidden = !!letter;
      if (full) full.hidden = !letter;
      hint.textContent = '';
      updateSiblings(letter);
    }

    document.addEventListener('variant:change', (event) => {
      if (!event.target || event.target.getAttribute('id') !== formId || !event.detail.variant) return;
      if (!isChosen()) return; // seçim kullanıcıdan gelmediyse (ör. tema içi senkron) kilit sürer
      chosen = true;
      unlockButtons();
      setChosenUI(event.detail.variant.options[idx]);
    });

    if (!chosen) {
      // Buy-buttons ve sabit çubuk DOM'a yerleşince kilitle
      lockButtons();
      requestAnimationFrame(lockButtons);
      window.addEventListener('load', () => { if (!chosen) lockButtons(); });
    } else {
      const checked = strip.querySelector(`input[name="${optionName}"]:checked`);
      setChosenUI(checked ? checked.value : '');
    }

    // Seçili harf görünür olsun
    const current = strip.querySelector('input:checked');
    if (current) {
      const tile = current.closest('.mi-tile');
      if (tile) strip.scrollLeft = Math.max(0, tile.offsetLeft - strip.clientWidth / 2 + tile.offsetWidth / 2);
    }

    // Şerit okları ve kenar maskesi
    const prev = root.querySelector('[data-mi-prev]'), next = root.querySelector('[data-mi-next]');
    const edges = () => {
      const max = strip.scrollWidth - strip.clientWidth - 2;
      strip.classList.toggle('is-start', strip.scrollLeft <= 2);
      strip.classList.toggle('is-end', strip.scrollLeft >= max);
      if (prev) prev.disabled = strip.scrollLeft <= 2;
      if (next) next.disabled = strip.scrollLeft >= max;
    };
    strip.addEventListener('scroll', edges, { passive: true });
    window.addEventListener('resize', edges);
    if (prev) prev.addEventListener('click', () => strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: 'smooth' }));
    edges();
  });
})();
